import React from 'react';
import Style from './Home.module.scss';
import { Box } from '@mui/material';
import RichText from '../RichText';
import { info } from '../../assets/info/Info';

export default function Home() {
  return (
    <Box component={'main'} className={Style.home}>
      <h1>
        Hi, I'm <span className={Style.name}>{info.firstName}</span>
      </h1>
      <p className={Style.tagline}>{info.tagline}</p>

      <blockquote className={Style.quote}>
        &ldquo;{info.quote.text}&rdquo; <span className={Style.cite}>― {info.quote.author}</span>
      </blockquote>

      <p className={Style.intro}>
        <RichText text={info.intro} />
      </p>

      <ul className={Style.bullets}>
        {info.miniBio.map((line, index) => (
          <li key={index}>{line}</li>
        ))}
      </ul>

      <Box className={Style.socials}>
        {info.socials.map((social, index) => (
          <a
            key={index}
            href={social.link}
            target={'_blank'}
            rel={'noopener noreferrer'}
            className={Style.socialLink}
          >
            {social.label}
          </a>
        ))}
      </Box>
    </Box>
  );
}
